import { ReactNode, useEffect } from "react";
import styles from "./style.module.scss";

import PageContainer from "@components/layout/PageContainer";
import { Table } from "reactstrap";
import CircleButton from "@components/content/CircleButton";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useAdminContext } from "@/hooks/useAdminContext";

export const TYPE_OF_DOCUMENTS: DocumentTypes = {
  invoice: "Facturas",
  quote: "Cotizaciones"
}

type DocumentTypes = {
  invoice: string;
  quote: string;
}

export type CustomFieldsTemplateIds = "invoice" | "quote";

const CustomFields = () => {
  const { profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const generateTableRows = (): ReactNode[] => {
    return Object.entries(TYPE_OF_DOCUMENTS).map(([type, title]) => {
      return (
        <tr className={styles.row}>
          <td>{title}</td>
          <td>
            <CircleButton to={`/user/custom-field/${type}${adminQuerySuffix}`} tooltip="Editar Informacion Personalizada" iconProps={{ icon: faEdit }} />
          </td>
        </tr>
      )
    })

  }

  return (
    <PageContainer
      title="Informacion personalizada"
      backUrl={profileBackUrl}
    >
      <Table striped bordered>
        <thead className={styles.header}>
          <tr>
            <td>
              Tipo De Documento
            </td>
            <td>
              Accion
            </td>
          </tr>
        </thead>
        <tbody>
          {generateTableRows()}
        </tbody>
      </Table>

    </PageContainer>
  );
}

export default CustomFields;
